import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/user_avatar.png")